module.exports = __webpack_public_path__ + "media/images/athletes/1811-ce9625b281889d8dd1cc4ccec94b7d5a.png";